// TODO: Remove this file and use types from fitbeat.models

enum Equipment {
  Bodyweight = 'Bodyweight',
  Dumbbells = 'Dumbbells',
  AerobicStep = 'Aerobic Step',
  SandBags = 'Sandbags',
  SlamBalls = 'Slam Balls',
  SpeedRope = 'Speed Rope',
  Bench = 'Bench',
  HomeBench = 'Home Bench',
  Pushbells = 'Pushbells',
  ShortUltrabands = 'Short Ultrabands',
  LongUltrabands = 'Long Ultrabands',
  UniversalBands = 'Universal Bands',
  Kettlebells = 'Kettlebells',
  BandsLowFixed = 'Bands Low Fixed',
  BandsHighFixed = 'Bands High Fixed',
}

enum Level {
  Basic = 'Basic', // Intermediate in app
  Intermediate = 'Intermediate', // Advanced in app
  Expert = 'Expert', // not used in app currently
  Beginner = 'Beginner', // Basic in app
}

enum CardioOrResistance {
  Cardio = 'Cardio',
  Resistance = 'Resistance',
  Balance = 'Balance',
}

interface IWorkoutSettings {
  level: Level;
  isDefaultDailyMix: boolean;
  allowBagContact: boolean;
  cardioOrResistance: CardioOrResistance;
  threeBodyGroups: string[]; // empty means no preference, thus all
  ignoreProgramRecommendations?: boolean;
  homeWorkoutInstructor?: string;
  equipment: Equipment[];
}

export interface ILiveStreamOptions {
  category?: string;
  topic?: string;
}

export interface IMakeBookingArguments {
  withPartner: boolean;
  startDateUTC: number;
  workoutType: number;
  gymName: string;
  isInstant: boolean;
  isDemo: boolean;
  timezone: string;
  workoutSettings?: IWorkoutSettings;
  isStudioDemo?: boolean;
  playbackSpeed?: number;
  livestreamOptions?: ILiveStreamOptions;
  isStreamingWorkout?: boolean;
  areaCategory?: string; // AreaCategory union type. use IAvailableStudioTimeSlots.areaCategory
}
